export const addQueryParameter = (url, queryParam, value) => {
  return url.indexOf('?') > -1
    ? `${url}&${queryParam}=${value}`
    : `${url}?${queryParam}=${value}`
}

export const Param = (location) => {}

// 서버 이미지 URL(/api/file/img/...)이면 ?variant=mobile 버전을 함께 제공.
// 정적/외부 URL이나 falsy 값은 그대로 반환해 폴백과의 호환성을 유지한다.
const isServedImage = (url) =>
  typeof url === 'string' && url.startsWith('/api/file/img/')

export const toMobileImage = (url) =>
  isServedImage(url) ? addQueryParameter(url, 'variant', 'mobile') : url

// URL 내부 공백/한글 안전 인코딩. `/`, `?`, `=`, `&` 등 구분자는 보존.
const safeEncode = (url) => (typeof url === 'string' ? encodeURI(url) : url)

// 뷰포트 기준으로 한 번만 판단해서 고정된 URL을 돌려주므로 리렌더가 발생하지 않음.
// 리사이즈 시 이미지를 다시 바꾸지는 않지만, 상세 페이지에서는 그 편이 부드럽다.
const pickVariantUrl = (url) => {
  const isMobileViewport =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(max-width: 768px)').matches
  return isMobileViewport ? toMobileImage(url) : url
}

// 상세 페이지 메인 이미지용 — 모바일에서는 800px, 데스크탑에서는 1600px 변형 사용.
export const getDetailImgProps = (url) => {
  if (!isServedImage(url)) return { src: url }
  return {
    src: safeEncode(pickVariantUrl(url)),
    loading: 'lazy',
    decoding: 'async',
  }
}

// HTML 본문(dangerouslySetInnerHTML)에 박혀있는 <img src="/api/file/img/..."> 를
// 뷰포트에 맞는 variant로 일괄 치환. 상세 페이지 리치 콘텐츠에 사용.
export const optimizeHtmlImages = (html) => {
  if (typeof html !== 'string') return html
  const isMobileViewport =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(max-width: 768px)').matches
  if (!isMobileViewport) return html
  return html.replace(
    /(<img\b[^>]*\bsrc=["'])(\/api\/file\/img\/[^"']+?)(["'])/gi,
    (_, pre, url, post) => `${pre}${toMobileImage(url)}${post}`
  )
}

// 썸네일은 카드 크기가 작아서 800px(mobile) 한 장으로 충분.
// srcset/sizes를 쓰지 않으므로 뷰포트 변화로 인한 이미지 재요청·리렌더 부담이 없다.
export const getThumbnailImgProps = (url) => {
  if (!isServedImage(url)) return { src: url }
  return {
    src: safeEncode(toMobileImage(url)),
    loading: 'lazy',
    decoding: 'async',
  }
}
